export const AbFeatureNames = {
  SIMONLYPLUS_UPSELL_DESIGN: 'SIMONLYPLUS_UPSELL_DESIGN',
  PX_ADDONS: 'PX_ADDONS',
  ESHOP_RECAPTCHA: 'ESHOP_RECAPTCHA',
  DELETE_PENDING_ORDER_FOR_NEW_FLOW: 'DELETE_PENDING_ORDER_FOR_NEW_FLOW'
};
